import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MdBldoCondition, MdBldo } from 'models/md/MdBldo';
import { callApi } from 'utils/ApiUtil';

/**
 * 형개발건물동 정보 목록 조회
 */
export const findMdBldoList = async (condition: MdBldoCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/bldo`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdBldo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdBldo[];
};

/**
 * 형개발건물동 정보 저장
 */
export const saveMdBldoList = async (masterData: MdBldo[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/bldo`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};
